import { CMSAdvancedShellFlowZone } from "@/pages/cms/advanced/shell-flow-zone";

export default function CMSAdvancedPiedDePage() {
  return <CMSAdvancedShellFlowZone step="FOOTER" />;
}
